export default {
    'remaining-samples': 'المواد المتبقية',
    'reason': 'السبب',
    'ravages': 'إتلاف',
    'free-distribution': 'توزيع مجاني',
    'returnable': 'قابلة للإعادة',
    'modify-transfer': 'تعديل مناقلة',
    'stocktaking': 'الجرد',
    'this-transfer': 'المناقلة'
}